import React from 'react';
import { Button } from './ui/button';
import { Phone, Clock, MapPin } from 'lucide-react';

const Hero = ({ onWhatsAppClick }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1714894691666-e8bb020c781c?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Water Heater"
          className="w-full h-full object-cover object-right"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-blue-600/20 backdrop-blur-sm border border-blue-500/30 rounded-full px-4 py-2 mb-6 animate-fade-in">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
            <span className="text-blue-400 text-sm font-medium">Service 24 Jam - Siap Melayani</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Service Water Heater
            {/* <span className="block text-red-600 mt-2">Modena Profesional</span> */}
            <span className="block text-blue-600 mt-2"> Profesional</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            Teknisi bersertifikat siap menangani segala kerusakan water heater Anda.
            Layanan cepat, garansi terjamin, harga transparan.
          </p>

          {/* Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 transition-all duration-300">
              <Clock className="w-6 h-6 text-blue-500 mb-2" />
              <div className="text-white font-semibold">24/7 Service</div>
              <div className="text-gray-400 text-sm">Setiap Hari</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 transition-all duration-300">
              <MapPin className="w-6 h-6 text-blue-500 mb-2" />
              <div className="text-white font-semibold">Area Jabodetabek</div>
              <div className="text-gray-400 text-sm">Respon Cepat</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4 hover:bg-white/15 transition-all duration-300">
              <Phone className="w-6 h-6 text-blue-500 mb-2" />
              <div className="text-white font-semibold">Gratis Konsultasi</div>
              <div className="text-gray-400 text-sm">Tanpa Biaya</div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={onWhatsAppClick}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-semibold rounded-xl shadow-2xl hover:shadow-blue-600/50 transition-all duration-300 hover:scale-105"
            >
              <Phone className="w-6 h-6 mr-2" />
              Hubungi via WhatsApp
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-6 text-lg font-semibold rounded-xl transition-all duration-300"
              onClick={() => document.getElementById('layanan').scrollIntoView({ behavior: 'smooth' })}
            >
              Lihat Layanan
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;